import type { RouteObject } from 'react-router';
import { LeadsPage } from '../leads/LeadsPage';

/** Pizzerias set up as test kitchens, moved here by hand. Their profiles stay at /leads/:id. */
export const routes: RouteObject[] = [{ path: '/test-kitchens', element: <LeadsPage segment="test_kitchen" /> }];
